import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-2" }

import { computed } from "vue";
import { useDateFormat, useTimeAgo } from "@vueuse/core";
import { get } from "@vueuse/core";
import {
  TIME_FORMAT,
  DATE_ISO_FORMAT,
  CURRENT_DATE_JP,
  PREVIOUS_DATE_JP,
  DATE_IN_WEEK_FORMAT,
  LINE_ACCOUNT_DATE_IN_MONTH_FORMAT,
  LINE_ACCOUNT_DATE_IN_YEAR_FORMAT,
  LINE_ACCOUNT_DATE_IN_PREVIOUS_YEAR_FORMAT,
} from "@/clinic/typings/constants/direct-message";

type ILineAccountShowTimeAgo = {
  date: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'show-time-ago',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as {
  date: string;
};



const showTimeAgo = computed((): string =>
  get(
    useTimeAgo(useDateFormat(props.date || new Date(), DATE_ISO_FORMAT), {
      fullDateFormatter: (date: Date) => date.toLocaleDateString(),
      messages: {
        justNow: CURRENT_DATE_JP,
        past: (n: any) => n,
        future: (n: any) => n,
        month: () => `${get(useDateFormat(props.date, LINE_ACCOUNT_DATE_IN_MONTH_FORMAT, { locales: "ja" }))}`,
        year: (n: number) => {
          return `${get(useDateFormat(props.date, LINE_ACCOUNT_DATE_IN_PREVIOUS_YEAR_FORMAT, { locales: "ja" }))}`;
        },
        day: (n: number) => {
          return n === 1
            ? PREVIOUS_DATE_JP
            : `${get(useDateFormat(props.date, DATE_IN_WEEK_FORMAT, { locales: "ja" }))}`;
        },
        week: (n: number) => {
          return `${get(useDateFormat(props.date, LINE_ACCOUNT_DATE_IN_MONTH_FORMAT, { locales: "ja" }))}`;
        },
        hour: () => get(useDateFormat(props.date, TIME_FORMAT)),
        minute: () => get(useDateFormat(props.date, TIME_FORMAT)),
        second: () => get(useDateFormat(props.date, TIME_FORMAT)),
        invalid: "invalid",
      },
    })
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.date ? _unref(showTimeAgo) : ""), 1))
}
}

})